export const userAccount = {
  loginForm: {
    title: 'Log in',
    forgotPassword: 'Forgot your password?',
    signIn: 'Log in',
    register: 'Register',
    dontHaveAccount: 'Don\'t have an account?',
    guestCheckout: 'Guest checkout',
    emailAddress: {
      label: 'Email address',
      placeholder: 'Enter your email',
    },
    password: {
      label: 'Password',
      placeholder: 'Password',
    },
    wrongEmailFormat: 'This is not a valid email format.',
  },
  miniLogin: {
    userGreeting: 'Hello, {{name}}',
    signInRegister: 'Log in / Register',
  },
};
